import React from 'react'
import LayoutTableItem from "./LayoutTableItem"

const LayoutTableBody = props => {
    const {error, listLayout} = props

    return (
        <tbody className="TableBody">
        {
            listLayout && listLayout.length > 0 ? listLayout.map((item, index) => (
                <LayoutTableItem
                    item={item}
                />
            )) : <tr className="NoRecord">
                <td colSpan={10}>Không có bản ghi nào</td>
            </tr>
        }

        {
            error && error.length > 0 && <tr className="NoRecord Error">
                <td colSpan={10}>{error}</td>
            </tr>
        }
        </tbody>
    )
}

LayoutTableBody.propTypes = {}

export default LayoutTableBody
